import {RemoveButton} from '@wallaby-ui/core';
import PropTypes from 'prop-types';
import * as React from 'react';
import {defineMessages} from 'react-intl';

export const I18N = defineMessages({
  REMOVE: {
    id: 'filter.remove',
    defaultMessage: 'Remove filter',
    description: 'title text for remove filter button',
  },
});

class FilterNodeRemoveButton extends React.PureComponent {
  render() {
    const {isVisible, item, removeFilter} = this.props;
    return isVisible ? (
      <span className={'float-end'}>
        <RemoveButton
          item={item}
          removeCallback={removeFilter}
          titleText={I18N.REMOVE.id}
        />
      </span>
    ) : null;
  }
}

FilterNodeRemoveButton.displayName = 'FilterNodeRemoveButton';

FilterNodeRemoveButton.propTypes = {
  isVisible: PropTypes.bool,
  item: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.objectOf(PropTypes.any),
  ]),
  removeFilter: PropTypes.func.isRequired,
};

FilterNodeRemoveButton.defaultProps = {
  isVisible: true,
  item: undefined,
};

export default FilterNodeRemoveButton;
